// matMixDensity.ts

export const Density: { Material: string, Variations?: { Name: string, Density: number }[], Density?: number }[] = [
  {
    Material: "CLEAR BOPP",
    Variations: [
      { Name: "CLEAR BOPP", Density: 0.92 },
    ]
  },
   {
    Material: "MET BOPP",
    Variations: [
      { Name: "MET BOPP", Density: 0.92 },
    ]
  },
   {
    Material: "MATT BOPP",
    Variations: [
      { Name: "MATT BOPP", Density: 0.88 },
    ]
  },
 
  {
    Material: "CLEAR PP",
    Variations: [
      { Name: "CLEAR PP", Density: 0.91 },
    ]
  },
   {
    Material: "PEARL BOPP",
    Variations: [
      { Name: "PEARL BOPP", Density: 0.69 },
    ]
  },
   {
    Material: "CLEAR PET",
    Variations: [
      { Name: "CLEAR PET", Density: 1.4 },
    ]
  }, 
  {
    Material: "CT PET",
    Variations: [
      { Name: "CT PET", Density: 1.4 },
    ]
  }, 
  {
    Material: "CC PET",
    Variations: [
      { Name: "CC PET", Density: 1.4 },
    ]
  }, {
    Material: "CT+CC PET",
    Variations: [
      { Name: "CT+CC PET", Density: 1.4 },
    ]
  }, 
  {
    Material: "SHRINK PET (PETG)",
    Variations: [
      { Name: "SHRINK PET (PETG)", Density: 1.32 },
    ]
  }, {
    Material: "MET PET",
    Variations: [
      { Name: "MET PET", Density: 1.4 },
    ]
  }, 
  {
    Material: "MATT PET",
    Variations: [
      { Name: "MATT PET", Density: 1.4 },
    ]
  }, 
  {
    Material: "PVC TWIST CLEAR",
    Variations: [
      { Name: "PVC TWIST CLEAR", Density: 1.36 },
    ]
  },
   {
    Material: "PVC SHRINK",
    Variations: [
      { Name: "PVC SHRINK", Density: 1.35 },
    ]
  },
   {
    Material: "PVC TWIST ORANGE",
    Variations: [
      { Name: "PVC TWIST ORANGE", Density: 1.36 },
    ]
  },
  {
    Material: "CPP MET",
    Variations: [
      { Name: "CPP MET", Density: 0.91 },
    ]
  },
  {
    Material: "CPP CLEAR",
    Variations: [
      { Name: "CPP CLEAR", Density: 0.91 },
    ]
  },
  {
    Material: "LDPE -SHRINK",
    Variations: [
      { Name: "LDPE -SHRINK", Density: 0.92 },
    ]
  },
  {
    Material: "LDPE LAMINATION",
    Variations: [
      { Name: "LDPE LAMINATION", Density: 0.92 },
    ]
  },
  {
    Material: "LDPE CLEAR",
    Variations: [
      { Name: "LDPE CLEAR", Density: 0.92 },
    ]
  },
  {
    Material: "LDPE WHITE",
    Variations: [
      { Name: "LDPE WHITE", Density: 0.92 },
    ]
  },
  {
    Material: "FOIL ALU",
    Variations: [
      { Name: "FOIL ALU", Density: 2.71 },
    ]
  },
  {
    Material: "WIP",
    Variations: [
      { Name: "WIP", Density: 1 },
    ]
  },
  // {
  //   Material: "MATT BOPP",
  //   Variations: [
  //     { Name: "MATT BOPP", Density: 0.88 },
  //   ]
  // },
  // {
  //   Material: "ADHESIVE",
  //   Density: 0.1 // Directly specify density for materials without variations
  // },
  // // Ensure there's an entry for ADDITIVES if needed
  // {
  //   Material: "ADDITIVES",
  //   Density: 0.97// Replace with actual density if known
  // },
  // {
  //         Material: "CLEAR BOPP",
  //         Variations: [
  //           { Name: "CLEAR BOPP", Density: 0.91 },
  //           { Name: "CLEAR BOPP [1010mm X 18μm]", Density: 0.91 },
  //           { Name: "CLEAR BOPP [1025mm X 18μm]", Density: 0.91 },
  //           { Name: "CLEAR BOPP [575 X18 MU ]", Density: 0.91 },
  //           { Name: "CLEAR BOPP [580mm X 18μm]", Density: 0.91 },
  //           { Name: "CLEAR BOPP [720mm X 40μm]", Density: 0.91 },
  //           { Name: "CLEAR BOPP [930mm X 18μm]", Density: 0.91 },
  //           { Name: "CLEAR BOPP [975mm X 18μm]", Density: 0.91 },
  //           { Name: "CLEAR BOPP[1020 X 40MU]", Density: 0.91 },
  //           { Name: "CLEAR BOPP[1025X18MU]", Density: 0.91 },
  //           { Name: "CLEAR BOPP[720X 40MU]", Density: 0.91 },
  //           { Name: "CLEAR BOPP[820 X18MU]", Density: 0.91 },
  //           { Name: "CLEAR BOPP[820mmx18MU]", Density: 0.91 },
  //           { Name: "CLEAR BOPP[880mm x40 MU]", Density: 0.91 },
  //           { Name: "CLEAR BOPP[885 X18MU]", Density: 0.91 },
  //           { Name: "CLEAR BOPP[895 X18MU]", Density: 0.91 },
  //           { Name: "CLEAR BOPP[920X30MU]", Density: 0.91 },
  //           { Name: "CLEAR BOPP[980X40MU]", Density: 0.91 },
  //         ],

  //       },
  //       {
  //                 Material: "MET BOPP",
  //                 Density: 0.91,

  //             },
  //             {
  //                       Material: "WHITE BOPP",
  //                       Density: 0.94,

  //                   },
  //                   {
  //                       Material: "PET",
  //                       Density: 1.40,

  //                   },
  //                   {
  //                       Material: "PEARLISED BOPP",
  //                       Density: 0.71,

  //                   },
  //                   {
  //                       Material: "NAT LDPE",
  //                       Density: 0.92,

  //                   },
  //                   {
  //                       Material: "WHITE LDPE",
  //                       Density: 0.94,

  //                   },
  //                   {
  //                       Material: "ALUMINIUM FOIL",
  //                       Variations: [
  //                         { Name: "ALUMINIUM FOIL", Density: 2.70 },
  //                       ]


  //                   },
  //                   {
  //                       Material: "NYLON FILM",
  //                       Density: 1.16,

  //                   },
  //                   {
  //                       Material: "PVC FILM",
  //                       Density: 1.30,

  //                   },
  //                   {
  //                       Material: "CPP",
  //                       Variations: [
  //                         { Name: "CLEAR CPP", Density: 0.91 },
  //                         { Name: "CLEAR CPP [610mm X 35μm]", Density: 0.91 },
  //                         { Name: "CLEAR CPP [915mm X 35μm]", Density: 0.91 }
  //                       ]

  //                   },
  //                   {
  //                       Material: "PAPER",
  //                       Density: 0.65,

  //                   },
  //                   {
  //                       Material: "LABEL FILM COSMO",
  //                       Density: 0.64,

  //                   },
  //                   {
  //                       Material: "LABEL FILM TGI",
  //                       Density: 1.40,

  //                   },
  //                   {
  //                       Material: "MET PET",
  //                       Density: 1.32,

  //                   },
  //                   {
  //                       Material: "PETG",
  //                       Density: 1.0, // Replace with actual density if known

  //                   },
  //                   {
  //                     Material: "INK",
  //                     Variations: [
  //                       { Name: "INK - ALPINE MAGENTA", Density: 1.0 },
  //                     { Name: "INK -LAMI PLUS MEDIUM", Density: 1.0 },
  //                     { Name: "INK -SI 22002 BOPP VERNA WHITE", Density: 1.0 },
  //                     { Name: "INK -SI 31501 POLY DF BLACK", Density:1.0 },
  //                     { Name: "INK -SI-32001 POLY DF WHITE", Density: 1.0 },
  //                     { Name: "INK ALPHA", Density: 1.0 },
  //                     { Name: "INK ALPINE", Density: 1.0 },
  //                     { Name: "INK ALPINE BLACK", Density: 1.0 },
  //                     { Name: "INK ALPINE BLOOD RED", Density: 1.0 },
  //                     { Name: "INK ALPINE FANTA GREEN", Density: 1.0 },
  //                     { Name: "INK ALPINE ORANGE", Density: 1.0 },
  //                     { Name: "INK ALPINE OVERCOTE", Density: 1.0 },
  //                     { Name: "INK ALPINE OVERCOTE MEDIUM", Density: 1.0 },
  //                     { Name: "INK AMAZ", Density: 1.0 },
  //                     { Name: "INK ASIS", Density: 1.0 },
  //                     { Name: "INK BOPP", Density: 1.0 },
  //                     { Name: "INK CT BOPP", Density: 1.0},
  //                     { Name: "INK CT BOPP BLACK", Density: 1.0 },
  //                     { Name: "INK CT BOPP CYAN", Density: 1.0 },
  //                     { Name: "INK CT BOPP GOLD LACQUER", Density:1.0 },
  //                     { Name: "INK CT BOPP MEDIUM", Density: 1.0 },
  //                     { Name: "INK CT BOPP NON ARSR MAGENTA", Density: 1.0 },
  //                     { Name: "INK CT BOPP OVERCOAT(OPV) MEDIUM", Density: 1.0 },
  //                     { Name: "INK CT BOPP SYNTHETIC GOLD", Density: 1.0 },
  //                     { Name: "INK CT BOPP WHITE", Density: 1.0 },
  //                     { Name: "INK CT BOPP YELLOW", Density: 1.0 },
  //                     { Name: "INK CT PET", Density: 1.0 },
  //                     { Name: "INK CT POLY", Density: 1.0 },
  //                     { Name: "INK CT POLY DF BLOOD RED", Density: 1.0 },
  //                     { Name: "INK CT POLY DF CYAN", Density: 1.0 },
  //                     { Name: "INK CT POLY DF MAGENTA", Density: 1.0 },
  //                     { Name: "INK CT POLY DF ORANGE", Density: 1.0 },
  //                     { Name: "INK CT POLY DF YELLOW", Density: 1.0 },
  //                     { Name: "INK CT PVC", Density: 1.0 },
  //                     { Name: "INK CT PVC RED", Density: 1.0 },
  //                     { Name: "INK CT PVC WHITE", Density: 1.0},
  //                     { Name: "INK CT PVC YELLOW", Density: 1.0 },
  //                     { Name: "INK PEONY", Density: 1.0 },
  //                     { Name: "INK PEONY BLACK", Density: 1.0 },
  //                     { Name: "INK PEONY BLOOD RED", Density: 1.0 },
  //                     { Name: "INK PEONY MAGENTA", Density: 1.0 },
  //                     { Name: "INK PEONY VIOLET", Density: 1.0 },
  //                     { Name: "INK PEONY WHITE", Density: 1.0},
  //                     { Name: "INK PET", Density: 1.0 },
  //                     { Name: "INK POLY", Density: 1.0 },
  //                     { Name: "INK PVC", Density: 1.0 },
  //                     { Name: "INK PVC ASIS MEDIUM", Density: 1.0 },
  //                     { Name: "INK PVC ASIS ORANGE", Density: 1.0 },
  //                     { Name: "INK RAINBOW", Density: 1.0 },
  //                     { Name: "INK SI BOPP", Density: 1.0 },
  //                     { Name: "INK SI PET", Density: 1.0 },
  //                     { Name: "INK SI POLY ", Density: 1.0 },
  //                     { Name: "INK-CT BOPP REFLEX BLUE", Density: 1.0 },
  //                     { Name: "INK-PEONY SILVER", Density: 1.0},
  //                     { Name: "INK-PVC ASIS MEDIUM", Density: 1.0 },
  //                     { Name: "INK-RAIN RS PEBO CYAN", Density: 1.0 },
  //                     { Name: "INK-RAIN RS PEBO MEDIUM", Density: 1.0 },
  //                     { Name: "INK-RAIN RS PVC MEDIUM", Density: 1.0 },
  //                     { Name: "INK-RAINBOW PRINT PEBO WHITE", Density: 1.0 },
  //                     { Name: "INK-SI 23011 BOPP BLOOD RED (NEW)", Density: 1.0 },
  //                     { Name: "INK-SI PET CYAN BLUE", Density: 1.0 },
  //                     { Name: "INK-SI PET MAGENTA", Density: 1.0 },
  //                     { Name: "INK-SI PET MEDIUM", Density: 1.0 },
  //                     { Name: "INK-SI-10001 PET CYAN BLUE 15:3", Density: 1.0 },
  //                     { Name: "INK-SI-10501 PET MAGENTA", Density: 1.0},
  //                     { Name: "INK-SI-10501 PET NON ARSR MAGENTA RED 57:1", Density: 1.0 },
  //                     { Name: "INK-SI-11506 PET BLACK", Density: 1.0 },
  //                     { Name: "INK-SI-12001 PET WHITE", Density: 1.0 },
  //                     { Name: "INK-SI-20001 BOPP CYAN BLUE 15:4", Density: 1.0 },
  //                     { Name: "INK-SI-20007 BOPP REFLEX BLUE", Density: 1.0 },
  //                     { Name: "INK-SI-2020 BOPP ADDITIVE", Density:1.0 },
  //                     { Name: "INK-SI-20501 BOPP NON ARSR MAGNETA RED 57:1", Density: 1.0 },
  //                     { Name: "INK-SI-21001 BOPP YELLOW 13", Density: 1.0 },
  //                     { Name: "INK-SI-21501 BOPP BLACK", Density: 1.0 },
  //                     { Name: "INK-SI-22001 BOPP WHITE (DRM)", Density: 1.0},
  //                     { Name: "INK-SI-22501 BOPP MEDIUM", Density: 1.0 },
  //                     { Name: "INK-SI-23010 BOPP RED CTL", Density: 1.0 },
  //                     { Name: "INK-SI-23501 BOPP ORANGE 34", Density: 1.0 },
  //                     { Name: "INK-SI-24501 BOPP NON ARSR VIOLET3", Density: 1.0 },
  //                     { Name: "INK-SI-2501 PET MEDIUM", Density: 1.0 },
  //                     { Name: "INK-SI-25501 BOPP SYNTHETIC GOLD", Density: 1.0},
  //                     { Name: "INK-SI-27001 BOPP OPV MEDIUM ", Density: 1.0 },
  //                     { Name: "INK-SI-27501 Synthetic Gold", Density: 1.0 },
  //                     { Name: "INK-SI-30001 POLY DF CYAN", Density: 1.0 },
  //                     { Name: "INK-SI-30501 POLY DF MAGENTA", Density: 1.0 },
  //                     { Name: "INK-SI-31001 POLY DF YELLOW", Density: 1.0 },
  //                     { Name: "INK-SI-32001 POLY DF WHITE", Density: 1.0 },
  //                     { Name: "INK-SI-32501 POLY DF MEDIUM", Density: 1.0 },
  //                     { Name: "INK-SI-33501 POLY DF ORANGE", Density:1.0},
  //                     { Name: "INK-SI-BOPP BLACK", Density: 1.0 },
  //                     { Name: "INK-SI-BOPP YELLOW", Density: 1.0 }
  //                     ]


  //                   },
];
  
// export const Density: { Material: string, Variations?: { Name: string, Density: number }[], Density?: number }[] = [
//     {
//         Material: "MATT BOPP",
//         Variations: [
//             { Name: "MATT BOPP", Density: 0.88 },
//         ]
//     },  

//     {
//       Material: "CLEAR BOPP",
//       Variations: [
//         { Name: "CLEAR BOPP", Density: 0.91 },
//         { Name: "CLEAR BOPP [1010mm X 18μm]", Density: 0.91 },
//         { Name: "CLEAR BOPP [1025mm X 18μm]", Density: 0.91 },
//         { Name: "CLEAR BOPP [575 X18 MU ]", Density: 0.91 },
//         { Name: "CLEAR BOPP [580mm X 18μm]", Density: 0.91 },
//         { Name: "CLEAR BOPP [720mm X 40μm]", Density: 0.91 },
//         { Name: "CLEAR BOPP [930mm X 18μm]", Density: 0.91 },
//         { Name: "CLEAR BOPP [975mm X 18μm]", Density: 0.91 },
//         { Name: "CLEAR BOPP[1020 X 40MU]", Density: 0.91 },
//         { Name: "CLEAR BOPP[1025X18MU]", Density: 0.91 },
//         { Name: "CLEAR BOPP[720X 40MU]", Density: 0.91 },
//         { Name: "CLEAR BOPP[820 X18MU]", Density: 0.91 },
//         { Name: "CLEAR BOPP[820mmx18MU]", Density: 0.91 },
//         { Name: "CLEAR BOPP[880mm x40 MU]", Density: 0.91 },
//         { Name: "CLEAR BOPP[885 X18MU]", Density: 0.91 },
//         { Name: "CLEAR BOPP[895 X18MU]", Density: 0.91 },
//         { Name: "CLEAR BOPP[920X30MU]", Density: 0.91 },
//         { Name: "CLEAR BOPP[980X40MU]", Density: 0.91 },
//       ],
        
//     },
//     {
//         Material: "MET BOPP",
//         Density: 0.91,
        
//     },
//     {
//         Material: "WHITE BOPP",
//         Density: 0.94,
        
//     },
//     {
//         Material: "PET",
//         Density: 1.40,
        
//     },
//     {
//         Material: "PEARLISED BOPP",
//         Density: 0.71,
        
//     },
//     {
//         Material: "NAT LDPE",
//         Density: 0.92,
        
//     },
//     {
//         Material: "WHITE LDPE",
//         Density: 0.94,
        
//     },
//     {
//         Material: "ALUMINIUM FOIL",
//         Variations: [
//           { Name: "ALUMINIUM FOIL", Density: 2.70 },
//         ]
       
        
//     },
//     {
//         Material: "NYLON FILM",
//         Density: 1.16,
        
//     },
//     {
//         Material: "PVC FILM",
//         Density: 1.30,
        
//     },
//     {
//         Material: "CPP",
//         Variations: [
//           { Name: "CLEAR CPP", Density: 0.91 },
//           { Name: "CLEAR CPP [610mm X 35μm]", Density: 0.91 },
//           { Name: "CLEAR CPP [915mm X 35μm]", Density: 0.91 }
//         ]
        
//     },
//     {
//         Material: "PAPER",
//         Density: 0.65,
        
//     },
//     {
//         Material: "LABEL FILM COSMO",
//         Density: 0.64,
        
//     },
//     {
//         Material: "LABEL FILM TGI",
//         Density: 1.40,
        
//     },
//     {
//         Material: "MET PET",
//         Density: 1.32,
        
//     },
//     {
//         Material: "PETG",
//         Density: 0, // Replace with actual density if known
        
//     },
//     {
//       Material: "INK",
//       Variations: [
//         { Name: "INK - ALPINE MAGENTA", Density: 0 },
//       { Name: "INK -LAMI PLUS MEDIUM", Density: 0 },
//       { Name: "INK -SI 22002 BOPP VERNA WHITE", Density: 0 },
//       { Name: "INK -SI 31501 POLY DF BLACK", Density: 0 },
//       { Name: "INK -SI-32001 POLY DF WHITE", Density: 0 },
//       { Name: "INK ALPHA", Density: 0 },
//       { Name: "INK ALPINE", Density: 0 },
//       { Name: "INK ALPINE BLACK", Density: 0 },
//       { Name: "INK ALPINE BLOOD RED", Density: 0 },
//       { Name: "INK ALPINE FANTA GREEN", Density: 0 },
//       { Name: "INK ALPINE ORANGE", Density: 0 },
//       { Name: "INK ALPINE OVERCOTE", Density: 0 },
//       { Name: "INK ALPINE OVERCOTE MEDIUM", Density: 0 },
//       { Name: "INK AMAZ", Density: 0 },
//       { Name: "INK ASIS", Density: 0 },
//       { Name: "INK BOPP", Density: 0 },
//       { Name: "INK CT BOPP", Density: 0 },
//       { Name: "INK CT BOPP BLACK", Density: 0 },
//       { Name: "INK CT BOPP CYAN", Density: 0 },
//       { Name: "INK CT BOPP GOLD LACQUER", Density: 0 },
//       { Name: "INK CT BOPP MEDIUM", Density: 0 },
//       { Name: "INK CT BOPP NON ARSR MAGENTA", Density: 0 },
//       { Name: "INK CT BOPP OVERCOAT(OPV) MEDIUM", Density: 0 },
//       { Name: "INK CT BOPP SYNTHETIC GOLD", Density: 0 },
//       { Name: "INK CT BOPP WHITE", Density: 0 },
//       { Name: "INK CT BOPP YELLOW", Density: 0 },
//       { Name: "INK CT PET", Density: 0 },
//       { Name: "INK CT POLY", Density: 0 },
//       { Name: "INK CT POLY DF BLOOD RED", Density: 0 },
//       { Name: "INK CT POLY DF CYAN", Density: 0 },
//       { Name: "INK CT POLY DF MAGENTA", Density: 0 },
//       { Name: "INK CT POLY DF ORANGE", Density: 0 },
//       { Name: "INK CT POLY DF YELLOW", Density: 0 },
//       { Name: "INK CT PVC", Density: 0 },
//       { Name: "INK CT PVC RED", Density: 0 },
//       { Name: "INK CT PVC WHITE", Density: 0 },
//       { Name: "INK CT PVC YELLOW", Density: 0 },
//       { Name: "INK PEONY", Density: 0 },
//       { Name: "INK PEONY BLACK", Density: 0 },
//       { Name: "INK PEONY BLOOD RED", Density: 0 },
//       { Name: "INK PEONY MAGENTA", Density: 0 },
//       { Name: "INK PEONY VIOLET", Density: 0 },
//       { Name: "INK PEONY WHITE", Density: 0 },
//       { Name: "INK PET", Density: 0 },
//       { Name: "INK POLY", Density: 0 },
//       { Name: "INK PVC", Density: 0 },
//       { Name: "INK PVC ASIS MEDIUM", Density: 0 },
//       { Name: "INK PVC ASIS ORANGE", Density: 0 },
//       { Name: "INK RAINBOW", Density: 0 },
//       { Name: "INK SI BOPP", Density: 0 },
//       { Name: "INK SI PET", Density: 0 },
//       { Name: "INK SI POLY ", Density: 0 },
//       { Name: "INK-CT BOPP REFLEX BLUE", Density: 0 },
//       { Name: "INK-PEONY SILVER", Density: 0 },
//       { Name: "INK-PVC ASIS MEDIUM", Density: 0 },
//       { Name: "INK-RAIN RS PEBO CYAN", Density: 0 },
//       { Name: "INK-RAIN RS PEBO MEDIUM", Density: 0 },
//       { Name: "INK-RAIN RS PVC MEDIUM", Density: 0 },
//       { Name: "INK-RAINBOW PRINT PEBO WHITE", Density: 0 },
//       { Name: "INK-SI 23011 BOPP BLOOD RED (NEW)", Density: 0 },
//       { Name: "INK-SI PET CYAN BLUE", Density: 0 },
//       { Name: "INK-SI PET MAGENTA", Density: 0 },
//       { Name: "INK-SI PET MEDIUM", Density: 0 },
//       { Name: "INK-SI-10001 PET CYAN BLUE 15:3", Density: 0 },
//       { Name: "INK-SI-10501 PET MAGENTA", Density: 0 },
//       { Name: "INK-SI-10501 PET NON ARSR MAGENTA RED 57:1", Density: 0 },
//       { Name: "INK-SI-11506 PET BLACK", Density: 0 },
//       { Name: "INK-SI-12001 PET WHITE", Density: 0 },
//       { Name: "INK-SI-20001 BOPP CYAN BLUE 15:4", Density: 0 },
//       { Name: "INK-SI-20007 BOPP REFLEX BLUE", Density: 0 },
//       { Name: "INK-SI-2020 BOPP ADDITIVE", Density: 0 },
//       { Name: "INK-SI-20501 BOPP NON ARSR MAGNETA RED 57:1", Density: 0 },
//       { Name: "INK-SI-21001 BOPP YELLOW 13", Density: 0 },
//       { Name: "INK-SI-21501 BOPP BLACK", Density: 0 },
//       { Name: "INK-SI-22001 BOPP WHITE (DRM)", Density: 0 },
//       { Name: "INK-SI-22501 BOPP MEDIUM", Density: 0 },
//       { Name: "INK-SI-23010 BOPP RED CTL", Density: 0 },
//       { Name: "INK-SI-23501 BOPP ORANGE 34", Density: 0 },
//       { Name: "INK-SI-24501 BOPP NON ARSR VIOLET3", Density: 0 },
//       { Name: "INK-SI-2501 PET MEDIUM", Density: 0 },
//       { Name: "INK-SI-25501 BOPP SYNTHETIC GOLD", Density: 0 },
//       { Name: "INK-SI-27001 BOPP OPV MEDIUM ", Density: 0 },
//       { Name: "INK-SI-27501 Synthetic Gold", Density: 0 },
//       { Name: "INK-SI-30001 POLY DF CYAN", Density: 0 },
//       { Name: "INK-SI-30501 POLY DF MAGENTA", Density: 0 },
//       { Name: "INK-SI-31001 POLY DF YELLOW", Density: 0 },
//       { Name: "INK-SI-32001 POLY DF WHITE", Density: 0 },
//       { Name: "INK-SI-32501 POLY DF MEDIUM", Density: 0 },
//       { Name: "INK-SI-33501 POLY DF ORANGE", Density: 0 },
//       { Name: "INK-SI-BOPP BLACK", Density: 0 },
//       { Name: "INK-SI-BOPP YELLOW", Density: 0 }
//       ]
       
        
//     },
//     {
//         Material: "ADHESIVE",
//         Density: 0.1, // Replace with actual density if known
        
//     }
// ]